// MeshPlugin Action Types Enum
export enum MeshPluginActions {
  SET_PLUGIN_ID = "SET_PLUGIN_ID",
  SET_UI_PAGES = "SET_UI_PAGES",
  SET_UI_DATA = "SET_UI_DATA",
  SET_SELECTED_UI_TYPE = "SET_SELECTED_UI_TYPE",
  SET_DEFINED_VARIABLES = "SET_DEFINED_VARIABLES",
  SET_IS_SAVED_SECTION = "SET_IS_SAVED_SECTION",
  SET_CONFIGURATION_DATA = "SET_CONFIGURATION_DATA",
  SET_SELECTED_CONFIG_DATA = "SET_SELECTED_CONFIG_DATA",
  SET_SELECTED_LOGIC_NAME = "SET_SELECTED_LOGIC_NAME",
  SET_CONFIG_VARIABLES = "SET_CONFIG_VARIABLES",
  SET_FIELD_NAME = "SET_FIELD_NAME",
  SET_FIELD_TYPE = "SET_FIELD_TYPE",
  SET_ACTION_FIELDS = "SET_ACTION_FIELDS",
  SET_DROPDOWN_OPTIONS = "SET_DROPDOWN_OPTIONS",
  SET_HAS_UNSAVED_FIELDS = "SET_HAS_UNSAVED_FIELDS",
  SET_HAS_UNSAVED_HELP_DOCS = "SET_HAS_UNSAVED_HELP_DOCS",
  SET_HELP_DOCS = "SET_HELP_DOCS",
  SET_INPUT_DEFAULT_VALUE = "SET_INPUT_DEFAULT_VALUE",
  SET_SAVED_SETTINGS = "SET_SAVED_SETTINGS",
  SET_SHOW_FORM = "SET_SHOW_FORM",
  SET_OPEN_MAPFIELDS_DIALOG = "SET_OPEN_MAPFIELDS_DIALOG",
  SET_HAS_UNSAVED_GENERAL_INFO = "SET_HAS_UNSAVED_GENERAL_INFO",
  SET_SELECTED_FORM_INDEX = "SET_SELECTED_FORM_INDEX",
  SET_SELECTED_SETTINGS_PAGE_INDEX = "SET_SELECTED_SETTINGS_PAGE_INDEX",
  SET_HAS_LOGIC_PAGE = "SET_HAS_LOGIC_PAGE",
  SET_HAS_UI_PAGE = "SET_HAS_UI_PAGE",
  SET_HAS_TEMP_CONFIG_PAGE = "SET_HAS_TEMP_CONFIG_PAGE",
}
